import { createAction, props } from '@ngrx/store';

import { Geolocation } from '@api/geolocation/models/geolocation.model';
import { DroppointListsDetail, DroppointListsRequestConfiguration, PickupFilter, PickupPointInfo } from '@api/store-locator/droppoint-lists/models/droppoint-lists.models';
import { PhysicalStoreDetail, PhysicalStoreRequestConfiguration } from '@api/store-locator/physical-store/models/physical-store.models';

export const PickupActions = {
    PICKUP_INITIALIZED: '[pickup] PICKUP_INITIALIZED',
    PICKUP_DESTROYED: '[pickup] PICKUP DESTROYED',

    LOAD_PICKUP_POINTS_BY_LOCATION: '[pickup] LOAD_PICKUP_POINTS_BY_LOCATION',

    LOAD_PICKUP_POINTS_BY_LOCATION_ERROR: '[pickup] LOAD_PICKUP_POINTS_BY_LOCATION_ERROR',

    SET_PICKUP_POINTS_BY_SEARCH_VALUE: '[pickup] SET_PICKUP_POINTS_BY_SEARCH_VALUE',
    GET_COORDINATES_FROM_SEARCH_VALUE_SUCESS: '[pickup] GET_COORDINATES_FROM_SEARCH_VALUE_SUCESS',
    GET_COORDINATES_FROM_SEARCH_VALUE_ERROR: '[pickup] GET_COORDINATES_FROM_SEARCH_VALUE_ERROR',

    SET_PICKUP_POINTS_BY_SEARCH_VALUE_SUCCESS: '[pickup] SET_PICKUP_POINTS_BY_SEARCH_VALUE_SUCCESS',
    SET_PICKUP_POINTS_BY_SEARCH_VALUE_ERROR: '[pickup] SET_PICKUP_POINTS_BY_SEARCH_VALUE_ERROR',
    // Estas acciones son necesarias porque actuan en conjunto con las tres de SET
    LOAD_SEARCHED_PICKUP_POINTS_SUCCESS: '[pickup] SEARCH_PICKUP_POINTS_SUCCESS',
    LOAD_SEARCHED_PICKUP_POINTS_ERROR: '[pickup] SEARCH_PICKUP_POINTS_ERROR',

    SET_PICKUP_POINTS_VIEW_MODE: '[pickup] SET_PICKUP_POINTS_VIEW_MODE',
    SET_SELECTED_PICKUP_POINT: '[pickup] SET_SELECTED_PICKUP_POINT',
    FIND_SELECTED_PICKUP_POINT_BY_ID: '[pickup] FIND_SELECTED_PICKUP_POINT_BY_ID',
    SET_PICKUP_FILTER: '[pickup] SET_PICKUP_FILTER',

    SET_PICKUP_CAPACITY_FEATURE_STATUS: '[pickup] SET_PICKUP_CAPACITY_FEATURE_STATUS',
    SET_PICKUP_CAPACITY_FILTER_VALUE: '[pickup] SET_PICKUP_CAPACITY_FILTER_VALUE',

    SET_PICKUP_FREE_DP_FILTER_COMMAND: '[pickup] SET_PICKUP_FREE_DP_FILTER_COMMAND',
    RESET_PICKUP_FREE_DP_FILTER_COMMAND: '[pickup] RESET_PICKUP_FREE_DP_FILTER_COMMAND',

    FIND_ALTERNATIVE_FREE_DROPPOINTS: '[pickup] FIND_ALTERNATIVE_FREE_DROPPOINT',
};

export const PickupInitialized = createAction(PickupActions.PICKUP_INITIALIZED);
export const PickupDestroyed = createAction(PickupActions.PICKUP_DESTROYED);

export const LoadPickupPointsByLocation = createAction(PickupActions.LOAD_PICKUP_POINTS_BY_LOCATION);
export const LoadPickupPointsByLocationError = createAction(PickupActions.LOAD_PICKUP_POINTS_BY_LOCATION_ERROR);

export const SetPickupPointsBySearchValue = createAction(
    PickupActions.SET_PICKUP_POINTS_BY_SEARCH_VALUE,
    props<{ payload: string }>(),
);

export const GetCoordinatesFromSearchValueSucess = createAction(
    PickupActions.GET_COORDINATES_FROM_SEARCH_VALUE_SUCESS,
    props<{ coordinates: Geolocation }>(),
);

export const GetCoordinatesFromSearchValueError = createAction(
    PickupActions.GET_COORDINATES_FROM_SEARCH_VALUE_ERROR,
);

export const SetPickupPointsBySearchValueSuccess = createAction(
    PickupActions.SET_PICKUP_POINTS_BY_SEARCH_VALUE_SUCCESS,
    props<{ payload: DroppointListsRequestConfiguration | PhysicalStoreRequestConfiguration }>(),
);
export const SetPickupPointsBySearchValueError = createAction(PickupActions.SET_PICKUP_POINTS_BY_SEARCH_VALUE_ERROR);

export const LoadSearchedPickupPointsSuccess = createAction(
    PickupActions.LOAD_SEARCHED_PICKUP_POINTS_SUCCESS,
    props<{ payload: DroppointListsDetail[] | PhysicalStoreDetail[] | PickupPointInfo[] }>(),
);
export const LoadSearchedPickupPointsError = createAction(
    PickupActions.LOAD_SEARCHED_PICKUP_POINTS_ERROR,
    props<{ error: any }>(),
);

export const SetSelectedPickupPoint = createAction(
    PickupActions.SET_SELECTED_PICKUP_POINT,
    props<{ payload: DroppointListsDetail | PhysicalStoreDetail }>(),
);

export const FindSelectedPickupPointById = createAction(
    PickupActions.FIND_SELECTED_PICKUP_POINT_BY_ID,
    props<{ id: string; kind: string }>(),
);

export const SetPickupPointsViewMode = createAction(PickupActions.SET_PICKUP_POINTS_VIEW_MODE, props<{ payload: 'list' | 'map' }>());

export const SetPickupFilter = createAction(PickupActions.SET_PICKUP_FILTER, props<{ payload: PickupFilter }>());

export const SetPickupCapacityFeatureStatus = createAction(
    PickupActions.SET_PICKUP_CAPACITY_FEATURE_STATUS,
    props<{ payload: boolean }>(),
);

export const SetPickupCapacityFilterValue = createAction(
    PickupActions.SET_PICKUP_CAPACITY_FILTER_VALUE,
    props<{ payload: boolean }>(),
);

export const SetPickupFreeDroppintFilterCommand = createAction(
    PickupActions.SET_PICKUP_FREE_DP_FILTER_COMMAND,
    props<{ latitude: number; longitude: number }>(),
);

export const ResetPickupFreeDroppintFilterCommand = createAction(
    PickupActions.RESET_PICKUP_FREE_DP_FILTER_COMMAND,
);

export const FindAlternativeFreeDroppointCommand = createAction(
    PickupActions.FIND_ALTERNATIVE_FREE_DROPPOINTS,
    props<{ payload: DroppointListsRequestConfiguration }>(),
);
